import { Lock, ShieldCheck, CreditCard, Server, Gift } from "lucide-react";

const ITEMS = [
  [Lock, "256-bit SSL Encrypted"],
  [ShieldCheck, "DPDP Act 2023 Compliant"],
  [CreditCard, "Razorpay Secured Payments"],
  [Server, "Indian Data Hosting"],
  [Gift, "14-Day Free Trial, No Credit Card Required"],
];

export default function TrustBar() {
  return (
    <section className="border-y border-border bg-muted/40" data-testid="trust-bar">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 py-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-5 gap-y-3.5">
        {ITEMS.map(([Icon, label]) => (
          <div key={label} className="flex items-center gap-2" data-testid={`trust-item-${label.split(" ")[0].toLowerCase()}`}>
            <Icon className="w-4 h-4 text-[#F97316] shrink-0" />
            <span className="text-[11.5px] sm:text-[12px] text-muted-foreground leading-snug">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
